import { render, staticRenderFns } from "./main-object.vue?vue&type=template&id=7452f790&scoped=true"
import script from "./main-object.vue?vue&type=script&lang=ts"
export * from "./main-object.vue?vue&type=script&lang=ts"
import style0 from "./main-object.vue?vue&type=style&index=0&id=7452f790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7452f790",
  null
  
)

export default component.exports